import { Link } from "react-router-dom";
import { useBranding } from "../../context/BrandingContext";

export const Logo = ({ size = "md", showText = false, className = "", variant = "dark" }) => {
  const { branding } = useBranding();
  const sizes = {
    sm: { img: "h-7", text: "text-lg" },
    md: { img: "h-9", text: "text-xl" },
    lg: { img: "h-11", text: "text-2xl" },
    sidebar: { img: "h-[46px]", text: "text-lg" },
  };

  const { img, text } = sizes[size] || sizes.md;

  // Use uploaded main logo if available, otherwise fall back to defaults
  const customLogo = branding?.main_logo_url;
  const defaultSrc = variant === "light" ? "/odesie-logo-color.png" : "/odesie-logo-white.png";
  const logoSrc = customLogo || defaultSrc;

  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`} aria-label="Odesie - Home">
      <img src={logoSrc} alt="Odesie" className={`${img} w-auto object-contain`} />
      {showText && (
        <span className={`font-bold ${text}`} style={{ fontFamily: "'Sora', sans-serif" }}>
          Odesie
        </span>
      )}
    </Link>
  );
};

export default Logo;
